module.exports = __webpack_public_path__ + "img/honer13.9d3265f4.jpg";